import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { BreakdownWorkedTime } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'
import { WorkedTimeData } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/lib/calculateWorkedTime'
import { formatDateRangeCopy } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/getDateRange'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'

import Bar from './Bar'

interface Props {
  workedTimeData: WorkedTimeData
  workedTimeBreakdown: BreakdownWorkedTime
}

const Overview = ({ workedTimeData, workedTimeBreakdown }: Props) => {
  const { stringDateFrom: startOn, dateToOrToday } = useAttendanceDateNavigator()
  const endOn = dateToString(dateToOrToday, 'backend')
  const { minutes } = workedTimeData

  return (
    <>
      <Box flexDirection="row" gap="s2">
        <Text size="200" weight="medium">
          {`${i18n.t('clock_in.sidepanel.worked_hours.period')}:`}
        </Text>
        <Text size="200" weight="medium">
          {formatDateRangeCopy(startOn, endOn)}
        </Text>
      </Box>

      <Box gap="s8">
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s2">
          <Text size="300" weight="medium">
            {i18n.t('clock_in.sidepanel.worked_hours.title')}
          </Text>

          <MinutesToText value={minutes} size="500" weight="medium" />
        </Box>

        <Bar workedTimeBreakdown={workedTimeBreakdown} />

        <Text size="200">{i18n.t('clock_in.sidepanel.worked_hours.description')}</Text>
      </Box>
    </>
  )
}

export default Overview
